import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Field, Modal } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';
import { WrapperBlock } from 'coreOld/elements';
import { ISelectedNote } from 'partsOld/types';

interface IProps {
  isAddCostOpen?: boolean;
  selectedNote: ISelectedNote;
  noteContent: string;
  setNoteContent: Dispatch<SetStateAction<string>>;
  onCreateNote: () => void;
  onEditNote: () => void;
  onCloseModal: () => void;
}

const AddCostNoteView = ({
  isAddCostOpen,
  selectedNote,
  noteContent,
  setNoteContent,
  onCreateNote,
  onEditNote,
  onCloseModal,
}: IProps) => {
  const { t } = useTranslation();

  const modalTitle = selectedNote ? t('labelEditNote') : t('labelCreateNote');
  const btnTitle = selectedNote ? t('buttonLabelUpdate') : t('buttonLabelCreate');

  return (
    <Modal title={modalTitle} isOpen={isAddCostOpen} onClose={onCloseModal} size={Size.MD}>
      <WrapperBlock>
        <Field
          type={InputType.TEXTEDITOR}
          inputProps={{
            value: noteContent,
            onChange: setNoteContent,
          }}
        />
      </WrapperBlock>

      <WrapperBlock hideBorderBottom buttonWrapper>
        <Button onClick={() => (selectedNote ? onEditNote() : onCreateNote())}>{btnTitle}</Button>
      </WrapperBlock>
    </Modal>
  );
};

export default AddCostNoteView;
